<div class="modal-header">
  <h1 id="modal-title" class="modal-title">Add Learn Video</h1>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="addReviewLoader"></myp-inline-loader>

  @if (!loading) {
    <div>
      <myp-segmented-bar
        (selected)="section = $event.id"
        [options]="[
          {
            name: 'Import Video By ID',
            id: 'videoId',
            selected: true,
          },
          {
            name: 'Import Playlist By ID',
            id: 'playlistId',
          },
        ]"
      ></myp-segmented-bar>
      @if (section == "videoId") {
        <div class="form-group m-t-20">
          <label class="control-label" for="videoId">Enter a YouTube or Vimeo video ID</label>
          <input type="text" name="videoId" id="videoId" [(ngModel)]="videoId" class="form-control" />
        </div>
      }
      @if (section == "playlistId") {
        <div class="form-group m-t-20">
          <label class="control-label" for="playlistId">Enter a YouTube Playlist ID, and the entire playlist will be added.</label>
          <input type="text" name="playlistId" id="playlistId" [(ngModel)]="playlistId" class="form-control" />
        </div>
        <div class="form-group m-t-20">
          <myp-switch [active]="createFolder" label="Create a Folder with Playlist Info" [labelToRight]="true" (toggle)="createFolder = !createFolder"></myp-switch>
        </div>
      }
      <div class="form-group m-t-20">
        <myp-switch [active]="markApproved" label="Mark as Approved" [labelToRight]="true" (toggle)="markApproved = !markApproved"></myp-switch>
      </div>
      <div class="form-group m-t-20">
        <label class="control-label" for="brand">Brand</label>
        <select name="brand" id="brand" [(ngModel)]="brand" class="form-control">
          <option value="presonus">PreSonus</option>
          <option value="fender">Fender</option>
        </select>
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" [disabled]="loading" class="btn btn-primary" (click)="submit()">
    <span>{{ "general.submit" | translate }}</span>
  </button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
